/**
 * Validate a transaction form and return an errors object.
 * Keys match form field names; values are error messages.
 * Returns an empty object when the form is valid.
 */
export const validateTransaction = (form) => {
  const errors = {};
  if (!form.description || !form.description.trim()) {
    errors.description = "Description is required";
  }
  if (!form.category) {
    errors.category = "Pick a category";
  }
  const amt = parseFloat(form.amount);
  if (!form.amount || isNaN(amt) || amt <= 0) {
    errors.amount = "Enter a valid amount";
  }
  if (!form.date) {
    errors.date = "Pick a date";
  }
  return errors;
};

export function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}
